export const DEFAULT_USERNAMES = [
  { _id: '0', nickname: 'caps', price: 5303 },
  { _id: 1, nickname: 'edit', price: 5303 },
  { _id: 2, nickname: 'hjsl', price: 5303 },
  { _id: 3, nickname: 'kyle', price: 5303 },
  { _id: 4, nickname: 'oakx', price: 5303 },
  { _id: 5, nickname: 'shfl', price: 5303 },
  { _id: 6, nickname: 'xxx1', price: 5303 },
  { _id: 7, nickname: 'xxx2', price: 5303 },
  { _id: 8, nickname: 'yiso', price: 5303 },
  { _id: 9, nickname: 'bigboss', price: 2256 },
  { _id: 10, nickname: 'majestic', price: 2127 },
  { _id: 11, nickname: 'metric', price: 1775 },
  { _id: 12, nickname: 't_r_u_m_p', price: 1676 },
  { _id: 13, nickname: 'clown', price: 1365 },
  { _id: 14, nickname: 'bullet', price: 1167 },
  { _id: 15, nickname: 'stalker', price: 1155 },
  { _id: 16, nickname: 'function', price: 1065 },
  { _id: 17, nickname: 'alive', price: 900 },
  { _id: 18, nickname: 'fameofcrypto', price: 840 },
  { _id: 19, nickname: 'insiders', price: 816 },
  { _id: 20, nickname: 'tiffanytrump', price: 788 },
  { _id: 21, nickname: 'daemon', price: 583 },
  { _id: 22, nickname: 'cyberclan', price: 557 },
  { _id: 23, nickname: 'mistermusk', price: 543 },
  { _id: 24, nickname: 'doges', price: 541 },
  { _id: 25, nickname: 'gamba', price: 541 },
  { _id: 26, nickname: 'respin', price: 541 },
  { _id: 27, nickname: 'shuffled', price: 541 },
  { _id: 28, nickname: 'shuffler', price: 541 },
  { _id: 29, nickname: 'stacked', price: 541 },
  { _id: 30, nickname: 'tasker', price: 541 },
  { _id: 31, nickname: 'klava', price: 333 },
  { _id: 32, nickname: 'zavod', price: 277 },
  { _id: 33, nickname: 'staya', price: 263 },
  { _id: 34, nickname: 'oooo1', price: 250 },
  { _id: 35, nickname: 'notidiot', price: 240 },
  { _id: 36, nickname: 'algoritm', price: 210 },
  { _id: 37, nickname: 'crypto5', price: 210 },
  { _id: 38, nickname: 'dtrade', price: 210 },
  { _id: 39, nickname: 'zitraks', price: 177 },
  { _id: 40, nickname: 'fucking_2025_new_year', price: 158 },
  { _id: 41, nickname: 'hajali', price: 158 },
  { _id: 42, nickname: 'dassaultaviation', price: 138 },
  { _id: 43, nickname: 'xurshid', price: 137 },
  { _id: 44, nickname: 'cryptosapp', price: 130 },
  { _id: 45, nickname: 'tokensapp', price: 130 },
  { _id: 46, nickname: 'ensvision', price: 120 },
  { _id: 47, nickname: 'betboom_ai', price: 116 },
  { _id: 48, nickname: 'donatovnetsupport', price: 116 },
  { _id: 49, nickname: 'eucrypto', price: 116 },
  { _id: 50, nickname: 'l888q', price: 112 },
  { _id: 51, nickname: 'v888a', price: 112 },
  { _id: 52, nickname: 'v888z', price: 112 },
  { _id: 53, nickname: 'x888v', price: 112 },
  { _id: 54, nickname: 'bybit9', price: 111 },
  { _id: 55, nickname: 'pauldurov', price: 111 },
  { _id: 56, nickname: 'aigame', price: 110 },
  { _id: 57, nickname: 'airdrop6', price: 110 },
  { _id: 58, nickname: 'airdrops3', price: 110 },
  { _id: 59, nickname: 'alert_whale', price: 110 },
  { _id: 60, nickname: 'apple2', price: 110 },
  { _id: 61, nickname: 'apple3', price: 110 },
  { _id: 62, nickname: 'apple4', price: 110 },
  { _id: 63, nickname: 'apple5', price: 110 },
  { _id: 64, nickname: 'aq666', price: 110 },
  { _id: 65, nickname: 'bandainamco', price: 110 },
  { _id: 66, nickname: 'basmanov', price: 110 },
  { _id: 67, nickname: 'binanceo', price: 110 },
  { _id: 68, nickname: 'binancex', price: 110 },
  { _id: 69, nickname: 'bitcoino', price: 110 },
  { _id: 70, nickname: 'bitcoinv', price: 110 },
  { _id: 71, nickname: 'cablenewsnetwork', price: 110 },
  { _id: 72, nickname: 'craftbet', price: 110 },
  { _id: 73, nickname: 'crypto6', price: 110 },
  { _id: 74, nickname: 'crypto_trading1', price: 110 },
  { _id: 75, nickname: 'cryptocurrency2', price: 110 },
  { _id: 76, nickname: 'cryptocurrencyy', price: 110 },
  { _id: 77, nickname: 'cryptou', price: 110 },
  { _id: 78, nickname: 'digital_assets', price: 110 },
  { _id: 79, nickname: 'dinex', price: 110 },
  { _id: 80, nickname: 'donatov_support', price: 110 },
  { _id: 81, nickname: 'epicbet', price: 110 },
  { _id: 82, nickname: 'ethereum2', price: 110 },
  { _id: 83, nickname: 'ethereumx', price: 110 },
  { _id: 84, nickname: 'europeancouncil', price: 110 },
  { _id: 85, nickname: 'everlove', price: 110 },
  { _id: 86, nickname: 'falconfinance', price: 110 },
  { _id: 87, nickname: 'fastvpnbot', price: 110 },
  { _id: 88, nickname: 'ffffd', price: 110 },
  { _id: 89, nickname: 'finance1', price: 110 },
  { _id: 90, nickname: 'financialx', price: 110 },
  { _id: 91, nickname: 'forex2', price: 110 },
  { _id: 92, nickname: 'forex3', price: 110 },
  { _id: 93, nickname: 'gems2', price: 110 },
  { _id: 94, nickname: 'gohighlevel', price: 110 },
  { _id: 95, nickname: 'gq444', price: 110 },
  { _id: 96, nickname: 'gx444', price: 110 },
  { _id: 97, nickname: 'hackz', price: 110 },
  { _id: 98, nickname: 'henniu', price: 110 },
  { _id: 99, nickname: 'hongbaojielong', price: 110 },

];
